import * as React from "react"
import {NavLink, useNavigate} from "react-router-dom";
import {ROUTES} from "../../helpers/constants";
import {getToken, setToken} from "../login/RequireAuth";

const headerLinks = [
  {text: "Home", to: ROUTES.home},
  {text: "Contact", to: ROUTES.contact},
  {text: "eLibrary", to: ROUTES.eLibrary},
  {text: "Downloads", to: ROUTES.downloads}
];

const Header = () => {

  const isLoggedIn = getToken();

  let navigate = useNavigate();


  const logOutClick = () => {
    setToken("");
    // window.location.href = "/login.html";
    navigate(ROUTES.login);
  }

  const contactClick = (event: any) => {
    event.preventDefault();
    const footer = document.querySelector(".footer");
    if (footer) {
      footer.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    }
  }

  return (
    <header className="header">
      <div className="container">
        <div className="flex flex--between">
          <div className="header-center" id="mainNav">
            <nav className="header-nav">
              <ul className="header-nav__list flex">
                {headerLinks.map(link => {
                  if (link.to === ROUTES.contact) {
                    return (
                      <li className="button-item" key={link.to}>
                        <a className={"header-link"} onClick={contactClick}>{link.text}</a>
                      </li>
                    )
                  }
                  return (
                    <li className="button-item" key={link.to}>
                      <NavLink className={({ isActive }) => "header-link" + (isActive ? " header-link--active" : "")}
                               to={link.to}>{link.text}</NavLink>
                    </li>
                  )
                })}
              </ul>
              <div className="header-mobile__unsubscribe text-center">
                <NavLink className={({ isActive }) => "link link--dashed" + (isActive ? " header-link--active" : "")}
                         to={ROUTES.unsubscribe}>Unsubscribe</NavLink>
              </div>
              <div className="header-mobile__login text-center">
                <a className="ui-button ui-button--small ui-button--darkblue" href="404.html">Sign In</a>
              </div>
            </nav>
          </div>
          <div className="header-right flex">
            <div className="button-item header-right__unsubscribe">
              <NavLink className={({ isActive }) => "header-link" + (isActive ? " header-link--active" : "")}
                       to={ROUTES.unsubscribe}>Unsubscribe</NavLink>
            </div>
            <div className="button-item">
              {isLoggedIn ? <span className={"ui-button ui-button--darkblue"} onClick={logOutClick}>Log Out</span> : null}
            </div>
          </div>
          <div className="hamburger" id="headerButton">
            <input className="hamburger-checkbox" id="hamburger" type="checkbox" />
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header